import React from 'react';
import { InstagramIcon, MailIcon, MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
const HOURS = [['Mon – Fri', '8:00 AM – 7:00 PM'], ['Saturday', '9:00 AM – 5:00 PM'], ['Sunday', 'Closed']];
export function Footer() {
  return <footer className="w-full bg-slate text-white" data-id="element-66" data-mp="32lrm3dfusxjz">
      <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8 sm:py-12" data-id="element-67" data-mp="36oo5h6d7wxoz">
        <div className="grid grid-cols-1 gap-8 sm:gap-10 lg:grid-cols-4" data-id="element-68" data-mp="3ufa3s5xf73ls">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-69" data-mp="38h4x8q3ngkf">
            <a href="#home" className="flex items-center gap-2" data-id="element-70" data-mp="37fun6gwqy3r">
              <img src="https://cdn.magicpatterns.com/uploads/iCSgMNo9mofRGomq3yMKNi/Logo_Ally_C.png" alt="Logo circular de Ally Cleaning Services" className="h-9 w-9 rounded-full object-contain" data-id="element-71" data-mp="3levg4zwzhcf4" />
              <span className="leading-tight" data-id="element-72" data-mp="2a19tbleljmwr">
                <span className="block font-display font-extrabold tracking-tight text-lg" data-id="element-73" data-mp="2eyjqxoc534vo">
                  Ally
                </span>
                <span className="block text-[10px] uppercase tracking-[0.22em] text-white/50 -mt-0.5" data-id="element-74" data-mp="3l9sjf6xt4wpj">
                  Cleaning Boutique
                </span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-75" data-mp="3v9axj6r1do9o">
              Boutique, eco-friendly cleaning for discerning homes across
              Manhattan, Queens, and Long Island.
            </p>
            <div className="mt-5 flex gap-3" data-id="element-76" data-mp="80xjc6sbqxik">
              <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" aria-label="Visit Ally Cleaning Services on Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-magenta transition-colors" data-id="element-77" data-mp="34gtn85h8b3d">
                <InstagramIcon className="h-5 w-5" data-id="element-78" data-mp="mrwpzc9lnbzi" />
              </a>
            </div>
          </div>

          {/* Hours */}
          <div data-id="element-79" data-mp="tvw66chqp7dv">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-80" data-mp="tw60uddqc2pw">
              <ClockIcon className="mr-2 inline h-4 w-4 text-sky-brand" data-id="element-81" data-mp="yv917kirlkrj" />
              Business Hours
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-white/60" data-id="element-82" data-mp="13rpokci53v3k">
              {HOURS.map(([day, time]) => <li key={day} className="flex justify-between gap-4" data-id="element-83" data-mp="18m3qkxrb50h7">
                  <span data-id="element-84" data-mp="1ckt2sn0m0bz9">{day}</span>
                  <span className="text-white/80" data-id="element-85" data-mp="1cnyqpyxi57te">{time}</span>
                </li>)}
            </ul>
            <p className="mt-3 text-xs font-medium text-sky-brand" data-id="element-86" data-mp="1mjsao3djw3l7">
              Yes — we&apos;re open Saturdays!
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-87" data-mp="1rgsiojtyngey">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-88" data-mp="1rgiosl5sop3z">
              Get in Touch
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-89" data-mp="3tb9mprujdtut">
              <li className="flex items-start gap-2" data-id="element-90" data-mp="2aevdxsrcbo5s">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-91" data-mp="2agolrbdowefd" />
                Manhattan · Queens · Long Island
              </li>
              <li className="flex items-start gap-2" data-id="element-92" data-mp="21mjzz6dext6p">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-93" data-mp="21n1u9xgilxbz" />
                <a href="mailto:allycleaningservices1@gmail.com" className="break-all hover:text-white transition-colors" data-id="element-94" data-mp="1wp0b7cj39y0i">
                  Email: allycleaningservices1@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-95" data-mp="2kcryfb663vgk">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-96" data-mp="2kbgn8qae7lff" />
                <a href="sms:+19296509940" className="hover:text-white transition-colors" data-id="element-97" data-mp="2fdoszpm9zn82">
                  Text/Call: (929) 650-9940
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-98" data-mp="1414isk0jys9j">
                <InstagramIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-brand" data-id="element-99" data-mp="2ruoi1bhm6u1j" />
                <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-id="element-100" data-mp="2wmzeu5h25zpv">
                  Instagram: @ally.cleaningservices
                </a>
              </li>
            </ul>
            <a href="#quote" className="mt-5 inline-flex rounded-full bg-magenta px-5 py-2.5 text-sm font-semibold text-white hover:bg-magenta-dark transition-colors" data-id="element-101" data-mp="3bki73hsy2v22">
              Book Now
            </a>
          </div>

          <div data-id="element-102" data-mp="36jkpb6buk313">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-white/90" data-id="element-103" data-mp="36j2hrdjqi2dv">
              Our Service Areas
            </h3>
            <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-5" data-id="element-104" data-mp="1v573s84kfzo8">
              <p className="text-sm leading-relaxed text-white/60" data-id="element-105" data-mp="1v346d313349h">
                Trusted boutique cleaning for homes and offices across:
              </p>
              <ul className="mt-4 space-y-3 text-sm font-medium text-white/85" data-id="element-106" data-mp="1im33wcg75den">
                {['Manhattan', 'Queens', 'Long Island'].map(area => <li key={area} className="flex items-center gap-2" data-id="element-107" data-mp="1rnsujg2988bd">
                    <MapPinIcon className="h-4 w-4 text-sky-brand" data-id="element-108" data-mp="1rlgcz40erzyu" />
                    {area}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-white/10 pt-6 text-center text-xs text-white/40 sm:mt-14 sm:flex-row sm:justify-between" data-id="element-109" data-mp="zuabok8ybw7z">
          <p data-id="element-110" data-mp="18w9u9gzm78d1">
            © {new Date().getFullYear()} Ally Cleaning Boutique NYC. All rights
            reserved.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-4" data-id="element-111" data-mp="l5e38m2zgh6u">
            <a href="#terms" className="transition-colors hover:text-white" data-id="element-112" data-mp="g7urbstrcgi2">
              Terms &amp; Conditions
            </a>
            <a href="#privacy" className="transition-colors hover:text-white" data-id="element-113" data-mp="2g8sybiv2nfay">
              Privacy Policy
            </a>
          </nav>
        </div>
      </div>
    </footer>;
}